export const API_BASE_URL =
  process.env.NODE_ENV === 'production' 
    ? (process.env.REACT_APP_API_BASE_URL || "https://spacepings.space")
    : (process.env.REACT_APP_API_BASE_URL || "http://127.0.0.1:5000");
